/**
 * Created by zzy on 2019/8/5.
 */
import EquipmentMonitoring from './EquipmentMonitoring.vue'
export default EquipmentMonitoring



// WEBPACK FOOTER //
// ./src/views/monitoring/equipmentMonitoring/index.js